import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface Dashboard {
  dashboard_id: string
  name: string
  bot_id: string
}

export async function deleteDashboard(
  botId: string,
  dashboardId: string,
): Promise<void> {
  await api.delete(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/bot/${botId}/dashboard/${dashboardId}`,
  )
}
